import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useI18n } from '@/i18n/i18n-provider';
import { Button } from '@/components/ui';

/**
 * The wizard's final step — reached only on success. A failed submission
 * stays on the step that made it (details or payment) with the error shown
 * right there, instead of advancing here; see `RegisterPage.submit`.
 */
export function ResultStep({
  churchName,
  onGoToApp,
}: {
  readonly churchName: string;
  readonly onGoToApp: () => void;
}): ReactNode {
  const { t } = useI18n();

  useEffect(() => {
    // A brief, visible confirmation before the redirect — an instant jump
    // reads as if nothing happened; matches the login page's own transition.
    const timer = setTimeout(onGoToApp, 1200);
    return () => clearTimeout(timer);
  }, [onGoToApp]);

  return (
    <div className="result-panel">
      <span className="result-icon" aria-hidden="true">
        ✓
      </span>
      <h2 className="auth-title">{t('registration.result.approvedTitle')}</h2>
      <p className="auth-subtitle">
        {t('registration.result.approvedBody', { values: { churchName } })}
      </p>
      <Button variant="primary" onClick={onGoToApp}>
        {t('registration.result.goToApp')}
      </Button>
    </div>
  );
}
